import { gql } from 'graphql-tag';

const sheetFragment = gql`
  fragment sheetDetail on Sheet {
    id
    sheet_type
    sheet_order
  }
`;

const sectionFragment = gql`
  fragment sectionDetail on BookSection {
    id
    name
    color
    section_order
    assigned_user {
      id
    }
  }
`;

const bookFragment = gql`
  fragment bookDetail on Book {
    id
    title
    total_pages
    community_id
    book_sections {
      ...sectionDetail
    }
  }
  ${sectionFragment}
`;

export const digitalMainQuery = gql`
  query digitalMain($bookId: ID!) {
    book(id: $bookId) {
      book_sections {
        due_date
        status
        sheets {
          is_visited
          ...sheetDetail
          digital_frames {
            id
            preview_image_url
            frame_order
            is_visited
          }
        }
      }
      ...bookDetail
    }
  }
  ${bookFragment}
  ${sheetFragment}
`;

// book: theme_id
// book / book_sections / sheets: theme_id
export const digitalEditorQuery = gql`
  query digitalEditor($bookId: ID!) {
    book(id: $bookId) {
      id
      book_user {
        id
        is_digital_photo_visited
      }
      digital_theme_id
    }
  }
`;

export const printMainQuery = gql`
  query printMain($bookId: ID!) {
    book(id: $bookId) {
      book_sections {
        due_date
        status
        sheets {
          id
          linked
          is_visited
          ...sheetDetail
          pages {
            id
            title
            preview_image_url
            show_page_number
          }
        }
      }
      ...bookDetail
    }
  }
  ${bookFragment}
  ${sheetFragment}
`;

// book: theme_id, page_info
// book / book_sections / sheets: theme_id
export const printEditorQuery = gql`
  query printEditor($bookId: ID!) {
    book(id: $bookId) {
      id
      number_max_pages
      book_user {
        id
        is_print_photo_visited
      }
      print_page_numbers
      print_theme_id
      page_number_position
      properties
      dimension {
        name
        id
        spread
        width
        height
      }
    }
  }
`;

export const managerQuery = gql`
  query managerQuery($bookId: ID!) {
    book(id: $bookId) {
      created_at
      number_max_pages
      yearbook_spec {
        cover_option
        delivery_option
        copies_sold
        fundraising_earned
        estimated_quantity_high
        estimated_quantity_low
        delivery_date
        phase_one_start_date
      }
      book_sections {
        draggable
        due_date
        status
        sheets {
          id
        }
      }
      ...bookDetail
    }
  }
  ${bookFragment}
`;

export const getDataGeneratePDFQuery = gql`
  query getBookCoverOption($bookId: ID!) {
    book(id: $bookId) {
      id
      yearbook_spec {
        cover_option
      }
      print_page_numbers
      page_number_position
      properties
      total_pages
      dimension {
        id
        name
        spread
        width
        height
      }
    }
  }
`;

export const getBookCoverOptionQuery = gql`
  query getBookCoverOption($bookId: ID!) {
    book(id: $bookId) {
      id
      yearbook_spec {
        cover_option
      }
    }
  }
`;

export const getSheets = gql`
  query getSheets($sectionId: ID!) {
    book_section(id: $sectionId) {
      id
      sheets {
        draggable
        fixed_position
        ...sheetDetail
        pages {
          id
          preview_image_url
        }
      }
    }
  }
  ${sheetFragment}
`;
